import React from "react";

import '../Style.css';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import MS_Platform from '../Assets/Images/Economic Scales/Platform Scale/MS_Platform_500x500mm.png'
import SS_Platform from '../Assets/Images/Economic Scales/Platform Scale/SS_Platform_500x500mm.png'
import Trolley from '../Assets/Images/Economic Scales/Platform Scale/Trolley_Scale.png'




function Platformscale() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">Platform Scale</p>

                    </div>
                    <div className="row   row-cols-lg-2 row-cols-1 min-vh-100 justify-content-center g-4 align-items-center ">

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Mild Steel ( MS ) platform
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={MS_Platform} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 100 kg</p>
                                            <p className="about-card-para-css">Accuracy : 10 g</p>
                                            <p className="about-card-para-css">Platform  Size ( mm ) : 400 x 400</p>
                                        </div>

                                        <a href="/MSplatform" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Stainless Steel ( SS ) Platform
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={SS_Platform} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 100 kg</p>
                                            <p className="about-card-para-css">Accuracy : 10 g</p>
                                            <p className="about-card-para-css">Platform Size ( mm ) : 400 x 400</p>
                                        </div>

                                        <a href="/SSplatform" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Trolley scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={Trolley} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 200 kg</p>
                                            <p className="about-card-para-css">Accuracy : 20 g</p>
                                            <p className="about-card-para-css">Platform Size ( mm ) : 450 x 550</p>
                                        </div>

                                        {/* <a href="/Micro" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a> */}

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>


        </div >

    );
}

export default Platformscale;
